import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

import { logout, verifyToken } from "network/ApiAxios";
import { publishAuthLogout, subscribeToAuthLogout } from "core/authEvents";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [session, setSession] = useState({ status: "checking", user: null });

    const verifySession = useCallback(async () => {
        try {
            const response = await verifyToken();
            if (response?.success) {
                setSession({ status: "authenticated", user: response.user });
                return;
            }
        } catch (error) {
        }
        setSession({ status: "anonymous", user: null });
    }, []);

    useEffect(() => {
        const unsubscribe = subscribeToAuthLogout(() => {
            setSession({ status: "anonymous", user: null });
        });
        verifySession();
        return unsubscribe;
    }, [verifySession]);

    const signIn = useCallback((user) => {
        setSession({ status: "authenticated", user });
    }, []);

    const signOut = useCallback(async () => {
        await logout();
        setSession({ status: "anonymous", user: null });
        publishAuthLogout();
    }, []);

    const value = useMemo(() => ({
        ...session,
        signIn,
        signOut,
    }), [session, signIn, signOut]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within AuthProvider");
    }
    return context;
};
